import { render, staticRenderFns } from "./AcceptInvitationButton.vue?vue&type=template&id=6cfbfc89&"
import script from "./AcceptInvitationButton.vue?vue&type=script&lang=js&"
export * from "./AcceptInvitationButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports